/**
 * Native shell bootstrap for Capacitor (iOS + Android).
 * Web build: this file is a no-op — Capacitor.isNativePlatform() returns false
 * and no plugins are touched, so browser users are unaffected.
 */
import { Capacitor } from "@capacitor/core";

export const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

export const nativePlatform = () => {
  try { return Capacitor?.getPlatform?.() || "web"; } catch { return "web"; }
};

/** Fire-and-forget: hide splash, style status bar, add native body class. */
export async function initNativeShell() {
  if (!isNative()) return;

  // Add a body class so CSS can adapt (safe areas, tap targets).
  document.body.classList.add("capacitor-native", `platform-${nativePlatform()}`);

  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#FAF9F6" }).catch(() => {});
  } catch { /* plugin unavailable */ }

  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    // Small delay lets React paint before we fade the splash.
    setTimeout(() => { SplashScreen.hide({ fadeOutDuration: 250 }).catch(() => {}); }, 400);
  } catch { /* plugin unavailable */ }

  try {
    const { App } = await import("@capacitor/app");
    // Prevent accidental back-to-exit on Android when there's history.
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
  } catch { /* plugin unavailable */ }
}
